import React from "react";
import { checkButtonAccess } from "../../../Utils/CommonUtils";

const CommonButton = ({
  handleSubmit,
  handleCancel,
  handleForm,
  edit,
  update,
  save,
  form,
  checkAccess = true,
  checkAccessProfile = true,
  isEditing,
  handleEdit,
  handleView,
}) => {
  if (update) {
    return (
      <div className="button-wrapper">
        <button
          // type="submit"
          className="btn btn-outline-primary cancel"
          onClick={handleCancel}
        >
          Cancel
        </button>
        {checkAccess && (
          <button
            type="submit"
            className="btn btn-primary save"
            id="addNewMember"
            onClick={handleSubmit}
          >
            Update
          </button>
        )}
      </div>
    );
  } else if (save) {
    return (
      <div className="button-wrapper">
        {checkAccess && (
          <button
            type="submit"
            className="btn btn-primary save"
            id="addNewMember"
            onClick={handleSubmit}
          >
            Update
          </button>
        )}
      </div>
    );
  } else if (form) {
    return (
      <div className="button-wrapper">
        <button
          // type="submit"
          className="btn btn-outline-primary cancel"
          onClick={handleCancel}
        >
          Cancel
        </button>
        {(checkButtonAccess ? checkButtonAccess("VIEW", "AGM_PRO") : true) && (
          <button
            type="button"
            className="btn btn-outline-primary cancel"
            onClick={handleForm}
          >
            Profile Form
          </button>
        )}
         {checkAccess && isEditing && (
           <button
           type="button"
           className="btn btn-outline-primary cancel"
           onClick={handleView}
         >
           View
         </button>
        )}
        {checkAccess && isEditing && (
          <button
            type="submit"
            className="btn btn-primary save"
            id="addNewMember"
            onClick={handleSubmit}
          >
            Update
          </button>
        )}
        {checkAccess && !isEditing && (
          <button
            type="button"
            className="btn btn-primary edit"
            id="editButton"
            onClick={handleEdit}
          >
            Edit
          </button>
        )}
      </div>
    );
  } else {
    return (
      <div className="button-wrapper">
        <button
          // type="button"
          className="btn btn-outline-primary cancel"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary save"
          id="addNewMember"
          onClick={handleSubmit}
        >
          {edit ? "Update" : "Save"}
        </button>
      </div>
    );
  }
};

export default CommonButton;
